/**
 * 自用蓝 — Figma 图片资源映射
 */
import classicGold from '../classic-gold/images';

const floatBallMap = {
  amToEn: require('@/components/FloatBall/self-blue/amToEn.png'),
  arToEn: require('@/components/FloatBall/self-blue/arToEn.png'),
  arToFr: require('@/components/FloatBall/self-blue/arToFr.png'),
  enToAm: require('@/components/FloatBall/self-blue/enToAm.png'),
  enToAr: require('@/components/FloatBall/self-blue/enToAr.png'),
  enToFr: require('@/components/FloatBall/self-blue/enToFr.png'),
  enToPt: require('@/components/FloatBall/self-blue/enToPt.png'),
  enToSw: require('@/components/FloatBall/self-blue/enToSw.png'),
  enToTh: require('@/components/FloatBall/self-blue/enToTh.png'),
  frToAr: require('@/components/FloatBall/self-blue/frToAr.png'),
  frToEn: require('@/components/FloatBall/self-blue/frToEn.png'),
  ptToEn: require('@/components/FloatBall/self-blue/ptToEn.png'),
  swToEn: require('@/components/FloatBall/self-blue/swToEn.png'),
  thToEn: require('@/components/FloatBall/self-blue/thToEn.png'),
};

export default {
  ...classicGold,
  banner: require('@/assets/self-blue/entry-hero.png'),
  header: require('@/assets/self-blue/entry-hero.png'),
  headerMobile: require('@/assets/self-blue/entry-hero.png'),
  bgi: require('@/assets/self-blue/entry-hero.png'),
  bgiMobile: require('@/assets/self-blue/entry-hero.png'),
  entryHero: require('@/assets/self-blue/entry-hero.png'),
  amountDeco: require('@/assets/self-blue/amount-deco.png'),
  paymentSelected: require('@/assets/self-blue/payment-selected.png'),
  paymentUnselected: require('@/assets/self-blue/payment-unselected.png'),
  warningIcon: require('@/assets/self-blue/warning-icon.png'),
  copyPayHero: require('@/assets/self-blue/copy-pay-hero.png'),
  copyWalletIcon: require('@/assets/self-blue/copy-wallet-icon.png'),
  floatBallMap,
  entryPreview: require('@/assets/self-blue/entry-preview.png'),
  copyPayPreview: require('@/assets/self-blue/copy-pay-preview.png'),
};
